import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { useTheme } from '../contexts/ThemeContext';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BookingCancelled = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--color-background)' }}>
      <Header />

      <div className="flex-1 flex items-center justify-center container mx-auto px-6 py-12">
        <div className="max-w-2xl w-full">
          <Card data-testid="cancelled-status" className="bg-white">
            <CardHeader className="text-center">
              <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center bg-yellow-100 rounded-full">
                <svg className="w-10 h-10 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <CardTitle 
                className="text-3xl sm:text-4xl" 
                style={{ fontFamily: 'var(--font-heading)', fontWeight: 'var(--font-heading-weight, 600)', color: 'var(--color-text-primary)' }}
              >
                Booking Cancelled
              </CardTitle>
            </CardHeader>
            <CardContent className="text-center space-y-6">
              <p style={{ fontFamily: 'var(--font-body)', color: 'var(--color-text-secondary)' }}>
                Your booking has been cancelled. No charges were made to your card.
              </p>
              <p style={{ fontFamily: 'var(--font-body)', color: 'var(--color-text-secondary)' }}>
                If you need assistance or want to try again, please don't hesitate to contact us.
              </p>
              <div className="flex gap-4 justify-center pt-4">
                <Button 
                  onClick={() => navigate('/')}
                  data-testid="return-home-button"
                  style={{ 
                    backgroundColor: 'var(--color-primary)', 
                    fontFamily: 'var(--font-body)' 
                  }}
                  className="hover:opacity-90"
                >
                  Return to Home
                </Button>
                <Button 
                  variant="outline"
                  onClick={() => navigate(-2)}
                  data-testid="try-again-button"
                  style={{ fontFamily: 'var(--font-body)' }}
                >
                  Try Again
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default BookingCancelled;
